/**
 * Sintetizador de tonos sonoros de aviso con Web Audio API.
 *
 * Emite una campana armónica sin necesidad de depender de archivos mp3 externos.
 */
let ctxAudio: AudioContext | null = null;

function obtenerContextoAudio(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (!ctxAudio) {
    const AudioContextClass = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    if (AudioContextClass) {
      ctxAudio = new AudioContextClass();
    }
  }
  if (ctxAudio && ctxAudio.state === 'suspended') {
    ctxAudio.resume().catch(() => null);
  }
  return ctxAudio;
}

/**
 * Tono claro de orden nueva en cocina: dos notas armónicas ascendentes.
 */
export function reproducirTonoOrdenNueva() {
  try {
    const ctx = obtenerContextoAudio();
    if (!ctx) return;

    const ahora = ctx.currentTime;

    // Nota 1 (Re5 - 587 Hz)
    const osc1 = ctx.createOscillator();
    const gain1 = ctx.createGain();
    osc1.type = 'sine';
    osc1.frequency.setValueAtTime(587.33, ahora);
    gain1.gain.setValueAtTime(0.3, ahora);
    gain1.gain.exponentialRampToValueAtTime(0.001, ahora + 0.25);
    osc1.connect(gain1);
    gain1.connect(ctx.destination);
    osc1.start(ahora);
    osc1.stop(ahora + 0.25);

    // Nota 2 (La5 - 880 Hz, 120ms después)
    const osc2 = ctx.createOscillator();
    const gain2 = ctx.createGain();
    osc2.type = 'sine';
    osc2.frequency.setValueAtTime(880.0, ahora + 0.12);
    gain2.gain.setValueAtTime(0.4, ahora + 0.12);
    gain2.gain.exponentialRampToValueAtTime(0.001, ahora + 0.5);
    osc2.connect(gain2);
    gain2.connect(ctx.destination);
    osc2.start(ahora + 0.12);
    osc2.stop(ahora + 0.5);
  } catch (err) {
    console.warn('[audio] No se pudo reproducir aviso sonoro:', err);
  }
}
